export class ViewClass {
  //litigations

  static LITIGATION_SERVICE_PREFIX = 'litigationServices:';

  static GET_LIST_OF_LITIGATIONS =
    this.LITIGATION_SERVICE_PREFIX + '_listOfLitigations';

  static GET_ARCHIVED_LITIGATIONS =
    this.LITIGATION_SERVICE_PREFIX + '_historyListOfLitigations';

  static DISPLAY_LITIGATION_METADATA =
    this.LITIGATION_SERVICE_PREFIX + '_displayLitigationMetadata';

  static ACTIONS_HISTORY_LIST =
    this.LITIGATION_SERVICE_PREFIX + '_historyListOfActionsOnLitigation';

  static DISPLAY_LITIGATION_METADATA_SUMMARY =
    this.LITIGATION_SERVICE_PREFIX + '_displayLitigationMetadataSummary';

  static DISPLAY_LOG_METADATA =
    this.LITIGATION_SERVICE_PREFIX + '_displayLogMetadata';

  static ASSIGN_LITIGATION =
    this.LITIGATION_SERVICE_PREFIX + '_assignLitigation';

  static DEASSIGN_LITIGATION =
    this.LITIGATION_SERVICE_PREFIX + '_deassignLitigation';

  static LIST_OF_PROCEDURAL_ACTS =
    this.LITIGATION_SERVICE_PREFIX + '_listOfProceduralActs';

  static UPDATE_PROCEDURAL_ACT =
    this.LITIGATION_SERVICE_PREFIX + '_updateProceduralAct';

  static LIST_OF_ENTITIES = this.LITIGATION_SERVICE_PREFIX + '_listOfEntities';

  static UPDATE_RESPONSIBLE_ENTITY =
    this.LITIGATION_SERVICE_PREFIX + '_updateResponsibleEntity';

  static REPORT_ISSUE = this.LITIGATION_SERVICE_PREFIX + '_reportIssue';

  static EXCLUDE_LITIGATION_FROM_GROUP =
    this.LITIGATION_SERVICE_PREFIX + '_excludeLitigationFromGroup';

  static DEACTIVATE_LITIGATION =
    this.LITIGATION_SERVICE_PREFIX + '_deactivateLitigation';

  static REACTIVATE_LITIGATION =
    this.LITIGATION_SERVICE_PREFIX + '_reactivateLitigation';

  static LIST_OF_TOPICS = this.LITIGATION_SERVICE_PREFIX + '_listOfTopics';

  static UPDATE_TOPIC = this.LITIGATION_SERVICE_PREFIX + '_updateTopic';

  static HISTORY_LIST_OF_ACTIONS_ON_LITIGATION =
    this.LITIGATION_SERVICE_PREFIX + '_historyListOfActionsOnLitigation';

  static UNARCHIVE_LITIGATION =
    this.LITIGATION_SERVICE_PREFIX + '_unarchiveLitigation';

  static EXPORT_LITIGATIONS =
    this.LITIGATION_SERVICE_PREFIX + '_exportLitigations';

  static EXPORT_LOGS = this.LITIGATION_SERVICE_PREFIX + '_exportLogs';

  static LIST_OF_LOGS = this.LITIGATION_SERVICE_PREFIX + '_listOfLogs';

  static LIST_OF_NOTIFICATIONS =
    this.LITIGATION_SERVICE_PREFIX + '_listOfNotifications';

  static DOWNLOAD_LITIGATION_DOCUMENT =
    this.LITIGATION_SERVICE_PREFIX + '_downloadLitigationDocument';

  static DOWNLOAD_USER_GUIDE =
    this.LITIGATION_SERVICE_PREFIX + '_downloadUserGuide';
}
